import React, {FC, useEffect, useState} from 'react';
import {Row, Calendar, Modal, Button, Descriptions, Spin, Alert} from "antd";
import {Moment} from "moment";
import {formatDate} from "../utls/formatDate";
import {useTypeSelector} from "../hooks/useTypeSelector";
import {IEvent} from "../models/eventModel";
import {useActions} from "../hooks/useActions";
import locale from 'antd/lib/calendar/locale/ru_RU'

const EventCalendar: FC = () => {
    const {events, isLoading, nearestTournament} = useTypeSelector(state => state.calendar);
    const [isVisible, setIsVisible] = useState(false);
    const [chosenEvent, setChosenEvent] = useState({} as IEvent | undefined);
    const {fetchEvents} = useActions();

    useEffect(() => {
        fetchEvents()
    }, []);

    const showModal = (e: React.MouseEvent<HTMLDivElement>) => {
        const id = e.currentTarget.getAttribute('data-id')!;
        const event = events.find(item => item.id === +id);
        setChosenEvent(event);
        setIsVisible(true);
    };

    const handleOk = () => {
        setIsVisible(false);
    };

    const handleCancel = () => {
        setIsVisible(false);
    };

    function dateCellRender(value: Moment) {
        const formatedDate = formatDate(value.toDate());
        console.log(formatedDate)
        const currentDayEvents = events.filter(item => item.date_start === formatedDate);
        if (currentDayEvents.length > 0) {
            return (
                <div onClick={e => showModal(e)}
                     data-id={currentDayEvents[0].id}
                     className='ant-picker-calendar-date-content-custom'
                ></div>);
        }
        return <></>;
    }

    return (
        <>{isLoading ?
            <div className="example">
                <Spin/>
            </div> :
            <>
                {nearestTournament &&
                <Alert
                    message="Ближайщий турнир"
                    description={`${nearestTournament.competition} дата: ${nearestTournament.date_start}`}
                    type="info"
                />}

                <Calendar locale={locale} fullscreen={false} dateCellRender={dateCellRender}/>

                <Modal title={chosenEvent?.competition} footer={null} visible={isVisible} onOk={handleOk}
                       onCancel={handleCancel}>
                    <Descriptions column={1}>
                        <Descriptions.Item label="Город">{chosenEvent?.city}</Descriptions.Item>
                        {chosenEvent?.status &&
                        <Descriptions.Item label="Статус соревнований">{chosenEvent.status}</Descriptions.Item>
                        }
                        <Descriptions.Item label="Дата начала">{chosenEvent?.date_start}</Descriptions.Item>
                        <Descriptions.Item label="Дата окончания">{chosenEvent?.date_finish}</Descriptions.Item>
                        {chosenEvent?.regulation && <Descriptions.Item label="Регламент">
                            <a target='_blank' href={chosenEvent.regulation}>Регламент</a>
                        </Descriptions.Item>
                        }
                    </Descriptions>
                    <Row justify='end'>
                        <Button onClick={handleOk} type="primary">Ok</Button>
                    </Row>
                </Modal>
            </>
        }
        </>
    );
};

export default EventCalendar;